require('./dist/angular-ismobile');
module.exports = 'ismobile';


//////////////////
// WEBPACK FOOTER
// ./~/angular-ismobile/index.js
// module id = 1563
// module chunks = 1